import { connect } from "react-redux";
import { useState } from "react";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory } from "react-router";
import StatusLayout from "components/Status";
import { IconButton } from "@mui/material";
import { de } from "date-fns/locale";
import BasicMenu from "helpers/menu";

function ProgramManagement({ location, SetSelectedMenu, FetchDetails, loggedUser, wholeStructure, structures }) {
  const [open, setOpen] = useState(0);
  const [value, setValue] = useState({});
  const [list, setList] = useState([]);
  const [id, setId] = useState();
  const [departments, setDepartments] = useState([]);

  const [count, setCount] = useState(0);

  const [deleteOpen, setDeleteOpen] = useState(false);

  const history = useHistory();

  useEffect(() => {
    SetSelectedMenu({
      menu: "program",
      title: "Program Management",
    });
    // console.log("location", loggedUser);
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    const response = await FetchDetails(`/api/structure/whole-structure`);
    if (response.status) {
      setDepartments(response?.data?.data[0]?.children || []);

    }
    // console.log("departments", response);
    
  };


    const [structurePath, setStructurePath] = React.useState([]);
    const [selectedStructure, setSelectedStructure] = React.useState();
  
    const getChildren = (parent, allStructures) => {
      const parentId = parent?.id || null;
      return allStructures.filter(s => s.parentId === parentId);
    };
    const institutionOptions = getChildren(null, wholeStructure);


  const columns = [
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-custom-blue text-xs ">{value}</span>
        ),
      },
    },
    {
      name: "startDate",
      label: "Start Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs">
            {moment(value).format("DD/MM/yyyy") ?? ""}
          </span>
        ),
      },
    },
    {
      name: "endDate",
      label: "End Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs">
            {moment(value).format("DD/MM/yyyy") ?? ""}
          </span>
        ),
      },
    },
    {
      name: "impact",
      label: "Impact",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span
            style={{
              color:
                value === "high"
                  ? "#FFA710"
                  : value === "medium"
                  ? "orange"
                  : "#E41010",
              fontSize: "13.92px",
            }}
            className={"text-custom-blue text-xs "}
          >
            {value}
          </span>
        ),
      },
    },
    {
      name: "projectCount",
      label: "Projects",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-custom-blue text-xs ">{value}</span>
        ),
      },
    },
    {
      name: "resource",
      label: "Assigned",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-custom-blue text-xs ">
            {value?.names ?? "N/A"}
          </span>
        ),
      },
    },
    {
      name: "completionPercentage",
      label: "Perfomance",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-custom-blue text-xs ">{
            `${parseFloat(value).toFixed(2)}%`
          }</span>
        ),
      },
    },
    {
      name: "division.name",
      label: "Structure",
    },
     
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (status) => {
          return (
            <span style={{ fontSize: "0.85rem" }}>
              <StatusLayout status={status == 'to-verify' ? 'under-review' : status} />
            </span>
          );
        },
      },
    },
     {
                name: "id",
                label: "Action",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (v) =>  <BasicMenu onDetails={() =>  history.push(`/admin/projects/${v}`, { program: list.find((x) => x.id === v) }) } onDelete={() => {
                      setId(v);setDeleteOpen(true);
                    }} onEdit={() => {
                      setId(v);
                      const divisionId = list.find((x) => x.id === v).divisionId;
                      const departmentId = departments.find((x) => x.children.some((division) => division.id === divisionId))?.id;
                      setValue({
                        name: list.find((x) => x.id === v).name,
                        code: list.find((x) => x.id === v).code,
                        startDate:  moment(list.find((x) => x.id === v).startDate).format("YYYY-MM-DD"),
                        endDate: moment(list.find((x) => x.id === v).endDate).format("YYYY-MM-DD"),
                        budget: list.find((x) => x.id === v).budget,
                        expenses: list.find((x) => x.id === v).expenses,
                        impact: list.find((x) => x.id === v).impact,
                        performance: list.find((x) => x.id === v).performance,
                        fundedBy: list.find((x) => x.id === v).fundedBy,
                        divisionId: list.find((x) => x.id === v).divisionId,
                         department: departmentId,
                        description: list.find((x) => x.id === v).description,
                      });
                      setOpen(2);
                     }} 
                  
                    
                     
                     />
                },
            }
  ];
  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };
  const onSuccess = () => setCount((v) => v + 1);
  return (
    <div className="w-full mb-12 px-4">
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={onSuccess}
        url={`/api/program/delete/${id}`}
      />

      <FormDialog
        maxWidth={"md"}
        col={6}
        open={open > 0}
        onSuccess={onSuccess}
        setOpen={setOpen}
        url={open === 1 ? "/api/program/create" : `/api/program/update/${id}`}
        title={open === 1 ? "Create New program" : "Edit program"}
        fields={[
          {
            name: "name",
            label: "Program name",
            value: value["name"],
            required: true,
            setValue: (val) => setValue0("name", val),
          },
          {
            name: "code",
            label: "Code",
            type: "text",
            value: value["code"],
            required: true,
            setValue: (val) => setValue0("code", val),
          },
          {
            name: "startDate",
            label: "Start Date",
            type: "date",
            value: value["startDate"],
            required: true,
            setValue: (val) => setValue0("startDate", val),
          },
          {
            name: "endDate",
            label: "End Date",
            type: "date",
            value: value["endDate"],
            required: true,
            setValue: (val) => setValue0("endDate", val),
          },
          // {
          //   name: "budget",
          //   label: "Budget",
          //   type: "number",
          //   isNumber: true,
          //   value: value["budget"],
          //   required: true,
          //   setValue: (val) => setValue0("budget", val),
          // },

          // {
          //   name: "expenses",
          //   label: "Expenditure",
          //   type: "number",
          //   isNumber: true,
          //   value: value["expenses"],
          //   required: true,
          //   setValue: (val) => setValue0("expenses", val),
          // },
          {
            name: "impact",
            label: "Impact",
            type: "select",
            values: [
              { label: "High", value: "high" },
              { label: "Medium", value: "medium" },
              { label: "Low", value: "low" },
            ],
            value: value["impact"],
            setValue: (val) => setValue0("impact", val),
          },
          {
            name: "currency",
            label: "currency",
            value: "Rwf",
            required: false,
            type: "text",
            hidden: true,
            setValue: (val) => setValue0("currency", val),
          },
          // {
          //   name: "department",
          //   label: "Select Department/Office",
          //   value: value["department"],
          //   values:
          //     departments &&
          //     departments.map((x) => ({
          //       label: x.name,
          //       value: x.id,
          //     })),
          //   required: false,
          //   type: "select",
          //   setValue: (val) => setValue0("department", val),
          // },
          // {
          //   name: "divisionId",
          //   label: "Division",
          //   value: value["divisionId"],
          //   values: departments
          //     .find((x) => x.id === value["department"])
          //     ?.children.map((x) => ({
          //       label: x.name,
          //       value: x.id,
          //     })),
          //   required: false,
          //   type: "select",
          //   setValue: (val) => setValue0("divisionId", val),
          // },
              {
            name: "institution",
            label: "Institution",
            type: "select",
            values: institutionOptions.map(opt => ({ label: opt.name, value: opt.id })),
            value: structurePath[0]?.id || "",
            required: true,
            setValue: (val) => {
              const selected = institutionOptions.find(opt => opt.id === val);
              const newPath = selected ? [selected] : [];
              setStructurePath(newPath);
              setSelectedStructure(selected);
              setValue0("structureId", selected?.id || "");
            }
          },
          ...(structurePath[0]?.children?.length > 0 ? [{
            name: "office",
            label: "Office",
            type: "select",
            values: (structurePath[0]?.children || []).map(opt => ({ label: opt.name, value: opt.id })),
            value: structurePath[1]?.id || "",
            required: false,
            setValue: (val) => {
              const selected = structurePath[0]?.children?.find(opt => opt.id === val);
              const newPath = selected ? [structurePath[0], selected] : [structurePath[0]];
              setStructurePath(newPath);
              setSelectedStructure(selected || structurePath[0]);
              setValue0("structureId", selected ? selected.id : structurePath[0].id);
            }
          }] : []),
          ...(structurePath[1]?.children?.length > 0 ? [{
            name: "dipartment",
            label: structurePath[2]?.category || "Department",
            type: "select",
            values: (structurePath[1]?.children || []).map(opt => ({ label: opt.name, value: opt.id })),
            value: structurePath[2]?.id || "",
            required: false,
            setValue: (val) => {
              const selected = structurePath[1]?.children?.find(opt => opt.id === val);
              const newPath = selected ? [structurePath[0], structurePath[1], selected] : [structurePath[0], structurePath[1]];
              setStructurePath(newPath);
              setSelectedStructure(selected || structurePath[1]);
              setValue0("structureId", selected ? selected.id : structurePath[1].id);
            }
          }] : []),
          ...(structurePath[2]?.children?.length > 0 ? [{
            name: "division",
            label: structurePath[3]?.category || "Unit",
            type: "select",
            values: (structurePath[2]?.children || []).map(opt => ({ label: opt.name, value: opt.id })),
            value: structurePath[3]?.id || "",
            required: false,
            setValue: (val) => {
              const selected = structurePath[2]?.children?.find(opt => opt.id === val);
              const newPath = selected ? [...structurePath.slice(0, 3), selected] : structurePath.slice(0, 3);
              setStructurePath(newPath);
              setSelectedStructure(selected || structurePath[2]);
              setValue0("structureId", selected ? selected.id : structurePath[2].id);
            }
          }] : []),
          {
            name: "description",
            label: "Description",
            value: value["description"],
            required: false,
            type: "textarea",
            col: 12,
            setValue: (val) => setValue0("description", val),
          },
        ]}
      />
      <DatatableComponent
        order={location.state?.order}
        onAddNew={() => setOpen(1)}
        processData={(data) => {
          setList(data.data);
          return data;
        }}
        onRowSelectionChange={(list) => {


        }
        }
        onRowClick={(rowData, { rowIndex }) => {
          const program = list[rowIndex];
          history.push(`/admin/projects/${program?.id}`, { program: program });
        }
        }
        
        elevation={1}
        pdf={false}
        excel={false}
        columns={columns}
        viewColumns={false}
        searchfield={true}
        search={false}
        url={`/api/program/list?count=${count}&status=${
          location.state?.status || ""
        }`} // Include the status filter in the URL
        title={"All Programs List"}
      />
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgramManagement);
